var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useEffect } from 'react';
import { useInView } from '@noom/wax-component-library';
import { useActionEvents } from '../../../core/providers/ActionProvider';
export function ImpressionTracker(_a) {
    var { children, timeInSeconds = 5, postId, className } = _a, options = __rest(_a, ["children", "timeInSeconds", "postId", "className"]);
    const actionEvents = useActionEvents();
    const timeoutRef = useRef();
    function handleVisible(isVisible) {
        if (!timeoutRef.current && isVisible) {
            timeoutRef.current = setTimeout(() => {
                var _a;
                (_a = actionEvents.onPostImpression) === null || _a === void 0 ? void 0 : _a.call(actionEvents, { postId });
            }, timeInSeconds * 1000);
        }
        else if (timeoutRef.current && !isVisible) {
            clearTimeout(timeoutRef.current);
        }
    }
    useEffect(() => () => clearTimeout(timeoutRef.current), []);
    const { ref } = useInView(Object.assign({ onChange: handleVisible, visibleThreshold: 1 }, options));
    return (React.createElement("div", { ref: ref, "data-type": "impression-tracker", className: className }, children));
}
//# sourceMappingURL=ImpressionTracker.js.map